import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.png';
import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Fetzer extends Component {

  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Fetzer</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Fetzer Headquater" />
        </div>
        <div className="supMainTextLS">
          <h1>Fetzer</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col xsHidden smHidden md={5}>
                <Carousel  controls={false} interval={3000}>
                  <Carousel.Item >
                      <img  src={InfoJumb1}  alt="Fetzer Palettenregal"  height="100%" />
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb2} alt="Fetzer Kabinen"  height="100%"/>
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb3} alt="Fetzer Desinfektionsspender"  height="100%" />
                  </Carousel.Item>
                </Carousel>
                </Col>
              <Col xsHidden md={7}>
                <h4>Die Firma Fetzer Regalbau GmbH & Co KG ist ein metallverarbeitender Betrieb mit Schwerpunkt auf der Fertigung von Regalanlagen jeglicher Art. Darüber hinaus fertigen wir kundenspezifische Metallkonstruktionen: Robotergestelle, Schallschutzkabinen, Arbeitsbühnen, Maschinen- Einhausungen sind nur einige aus unserem großen Repertoire.
                Neben den Dienstleistungen, die im Zusammenhang mit der Realisierung der individuellen Lagersystem-Lösung stehen, bietet Fetzer außerdem Regalprüfungen an, um die Sicherheit und Konformität auch im Betrieb vor Ort zu gewährleisten.
                Außerdem bietet Fetzer als Dienstleister Pulverbeschichtungen jeglicher Art für Werkstücke entsprechend Ihren Wünsche und Anforderungen.
              </h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>
                <h4>Die Firma Fetzer Regalbau GmbH & Co KG ist ein metallverarbeitender Betrieb mit Schwerpunkt auf der Fertigung von Regalanlagen jeglicher Art. Darüber hinaus fertigen wir kundenspezifische Metallkonstruktionen: Robotergestelle, Schallschutzkabinen, Arbeitsbühnen, Maschinen- Einhausungen sind nur einige aus unserem großen Repertoire.
              </h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="https://www.fetzer-regalbau.com/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
        </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Gründliche Fachberatung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Sorgfältige Planung und CAD-Konstruktion</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Hochwertige Fertigung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Profi-Qualität</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Fachmontage</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Regalprüfung</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h5>&#9658; &nbsp; Gründliche Fachberatung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h5>&#9658; &nbsp; Sorgfältige Planung und CAD-Konstruktion</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Hochwertige Fertigung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Profi-Qualität</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Fachmontage</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Regalprüfung</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <center>
          <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={6} sm={6}>
              <center>
              <Link to="/Suppliers/Fetzer/Lager"><h4 className="buttonBlue">Lagersysteme und -bühnen </h4></Link>
            </center>
            </Col>
            <Col  xs={6} sm={6}>
              <center>
              <Link to="/Suppliers/Fetzer/Sonstiges"><h4 className="buttonBlue" >Sonstiges</h4></Link>
            </center>
            </Col>

          </Row>

        </Grid>
        <br/>
      </section>
        </div>
    );
  }
}

export default Fetzer;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/fetzer/mainPageSup.js